import { render } from "./CmsView.vue?vue&type=template&id=0d601a8d"
import script from "./CmsView.vue?vue&type=script&lang=js"
export * from "./CmsView.vue?vue&type=script&lang=js"

import exportComponent from "C:\\src\\Inmersys\\tres-prima\\mundo-zac-webapp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__